/**
 * DetailMetadata component.
 */
import Context from '@shared/components/utils/context/detailContext';
import Container from '@components/atoms/container/detailMetadataContainer';
import Item from '@components/elements/detail/detailMetadataItem';
import { useContext } from 'react';

/**
 * Displays the detail metadata section.
 */
export default function DetailMetadata() {
  const { metadata } = useContext(Context);
  if (!metadata) return null;
  const { crew, originalTitle } = metadata;
  const { directors, actors, writers } = crew || {};
  const data = { originalTitle, directors, actors, writers };
  return (
    <Container id={'detailMetadata'}>
      {Object.values(data).map((item, key) => {
        return <Item key={key} title={item?.title} value={item?.value} />;
      })}
    </Container>
  );
}
